import Image from '../ui/Image/Image'
import styles from './DataNotfound.module.scss'
import notFound from '../../assets/images/notFound.svg'
import classNames from 'classnames'

function DataNotfound({ description: title, subTitle, descriptionClass }) {
  return (
    <div className={styles.noCardContainer}>
      <Image src={notFound} alt="Not Found" />
      <div className={styles.textContainer}>
        <span className={classNames(styles.description, descriptionClass)}>
          {title}
        </span>
        {subTitle && <span className={styles.subTitle}>{subTitle}</span>}
      </div>
    </div>
  )
}

export default DataNotfound
